/**
 * SkipToContent — accessibility helper.
 *
 * Hidden until keyboard focus. On focus, slides into the top-left as a
 * navy pill linking to #main-content. Pair with Layout.jsx which sets
 * `<main id="main-content" tabIndex={-1}>`.
 */
export default function SkipToContent({ lang }) {
  const label = lang === "ja" ? "本文へスキップ" : "Skip to content";
  return (
    <a
      href="#main-content"
      data-testid="skip-to-content"
      className={[
        // hidden off-screen by default; visible only on keyboard focus
        "sr-only focus:not-sr-only",
        "focus:fixed focus:top-3 focus:left-3 focus:z-[100]",
        "focus:inline-flex focus:items-center focus:gap-2",
        "focus:bg-[#5B2E83] focus:text-white",
        "focus:px-4 focus:py-2 focus:text-[13px] focus:font-medium focus:tracking-tight",
        "focus:outline-none focus:ring-2 focus:ring-[#0E5FB0] focus:ring-offset-2",
        "focus:shadow-[0_8px_24px_-12px_rgba(15,29,45,0.45)]",
      ].join(" ")}
    >
      {label}
    </a>
  );
}
